import {channelOfSnapshots} from './sagas'
import {getMstStore} from '$src/bootstrap/rootSaga'
import {IStore} from '$src/bootstrap/Store'
import {take} from 'redux-saga/effects'
import {getSnapshot, applySnapshot} from 'mobx-state-tree'

export default function* watchAndRevertResearchStateIfFrozen(
  hcid: string,
): Generator {
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const treeNode = mstStore.researchStates.byHousingCorporationId.get(hcid)!
  const theChannel: $FixMe = yield channelOfSnapshots(treeNode)
  let lastHealthySnapshot = getSnapshot(treeNode)
  while (true) {
    yield take(theChannel)
    if (mstStore.housingCorporations.byId.get(hcid)!.isFrozen()) {
      console.error(
        `Housing corporation is frozen, yet researchState has changed. This should never happen. Investigate.`,
      )
      applySnapshot(
        mstStore.researchStates.byHousingCorporationId.get(hcid)!,
        lastHealthySnapshot,
      )
      continue
    } else {
      lastHealthySnapshot = getSnapshot(
        mstStore.researchStates.byHousingCorporationId.get(hcid)!,
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/sagas/watchAndRevertResearchStateIfFrozen.ts